import site from "./site.json";

const serviceAreas = site.areas.map((area) => ({
  ...area,
  route: `/service-areas/${area.slug}`,
  heading: `${area.name} Carpet Cleaning`,
  summary: site.pages.find((page) => page.area === area.slug).intro,
  cities: area.cities,
}));

const serviceAreaMap = serviceAreas.reduce((map, area) => {
  map[area.slug] = area;
  return map;
}, {});

const pageMap = site.pages.reduce((map, page) => {
  map[page.path] = page;
  return map;
}, {});

export { site, serviceAreas, serviceAreaMap, pageMap };
